// removed by extract-text-webpack-plugin
module.exports = {"totalCell":"dosage-table__totalCell___1uH3U"};


//////////////////
// WEBPACK FOOTER
// ./core/src/components/prescription/dosage-table.css
// module id = 1180
// module chunks = 0